import CountriesEnum from '~/enums/CountriesEnum'

export const DELIVERY_PAYMENT_URLS = {
  [CountriesEnum.Lithuania]: {
    visa: 'https://stripe.com/en-gb-lt',
    paysera: 'https://www.paysera.lt/v2/lt-LT/index',
    paypal: 'https://www.paypal.com/us/home',
    mastercard: 'https://stripe.com/en-gb-lt',
    dpd: 'https://www.dpd.com/lt/lt/',
    omniva: 'https://www.omniva.lt/',
    aec: 'https://aecparcel.com',
  },
  [CountriesEnum.Latvia]: {
    visa: 'https://stripe.com/en-gb-lv',
    paysera: 'https://www.paysera.lv',
    paypal: 'https://www.paypal.com/us/home',
    mastercard: 'https://stripe.com/en-gb-lv',
    dpd: 'https://www.dpd.com/lv/lv/',
    omniva: 'https://www.omniva.lv/',
    aec: 'https://aecparcel.com',
  },
  [CountriesEnum.Estonia]: {
    visa: 'https://stripe.com/en-gb-ee',
    paysera: 'https://paysera.ee/',
    paypal: 'https://www.paypal.com/us/home',
    mastercard: 'https://stripe.com/en-gb-ee',
    dpd: 'https://www.dpd.com/ee/et/',
    omniva: 'https://www.omniva.ee/',
    aec: 'https://aecparcel.com',
  },
}
